import * as z from 'zod'
import { dateSchema } from '~/shared/lib/schemas'
import { ApiModel } from './core'

const attributesSchema = z.object({
  internalId: z.number(),
  protocolDate: z.string(),
  protocolNumber: z.string(),
  odpsCode: z.string(),
  odpsName: z.string(),
  odpsAddr: z.string(),
  penaltyDatetime: z.string(),
  penaltyLocation: z.string(),
  penaltyLawArticleCode: z.string(),
  penaltyLawArticleNumber: z.string(),
  penaltyLawArticleDescription: z.string(),
  penaltyMetaData: z.string(),
  carPlateNumber: z.string(),
  carVin: z.string(),
  carBrandTitle: z.string(),
  carModelTitle: z.string(),
  carSts: z.string(),
  id: z.string(),
  carExtId: z.string(),
  carMetaData: z.string(),
  paymentOrgInn: z.string(),
  paymentUin: z.string(),
  paymentType: z.string(),
  driverExtId: z.string(),
  paymentPayIdentifier: z.string(),
  paymentAmount: z.number(),
  paymentDiscountSize: z.number(),
  paymentDiscountDate: z.string(),
  paymentAmountTotal: z.number(),
  paymentUntilDate: z.string(),
  paymentIsPaid: z.boolean(),
  paymentAdditionalInfo: z.string(),
  paymentAmountTotalDiscount: z.string(),
  paymentMetaData: z.string(),
  paymentIsPaidPartial: z.boolean(),
  recipient: z.string(),
  recipientInn: z.string(),
  recipientKpp: z.string(),
  recipientBankAccountNumber: z.string(),
  recipientBankCorrAccountNumber: z.string(),
  recipientBankName: z.string(),
  recipientBankBik: z.string(),
  recipientBankPurpose: z.string(),
  recipientBankUsername: z.string(),
  recipientBankKbk: z.string(),
  recipientBankOktmo: z.string(),
  recipientBankSign: z.string(),
  recipientBankBilldate: z.string(),
  tmsSubdivision: z.string(),
  tmsSubdivisionName: z.string(),
  tmsDriver: z.string(),
  tmsDriverName: z.string(),
  comment: z.string(),
  bankclientExported: z.boolean(),
  bankclientLastExportDate: z.string(),
  bankclientLastExportAmount: z.string(),
  canDiscount: z.boolean(),
  dayUntilDiscountEnd: z.number(),
  dayUntilPayEnd: z.number(),
  bankclientLastExportCompanyBankDetailId: z.string(),
  paymentOrgName: z.string(),
  paymentAmountDriver: z.string(),
  taxiparkId: z.string(),
  files: z.array(
    z.object({
      uuid: z.string(),
      previewUrl: z.string(),
      originalUrl: z.string(),
    }),
  ),
})

const schema = z
  .object({
    createdAt: dateSchema,
    updatedAt: dateSchema,
  })
  .merge(attributesSchema)

export type OtherChargeAttributes = z.infer<typeof schema>

export class OtherCharge extends ApiModel<
  typeof schema,
  OtherChargeAttributes
> {
  static jsonApiType = 'other-charges'

  getPenaltyDatetime(): string {
    return this.getAttribute('penaltyDatetime')
  }

  getCreatedAt(): string {
    return this.getAttribute('createdAt')
  }

  getProtocolNumber(): string {
    return this.getAttribute('protocolNumber')
  }

  getProtocolDate(): string {
    return this.getAttribute('protocolDate')
  }

  getFiles(): OtherChargeAttributes['files'] {
    return this.getAttribute('files')
  }

  getBrandModel(): string {
    const brand = this.getAttribute('carBrandTitle')
    const model = this.getAttribute('carModelTitle')

    if (brand && model) return `${brand} ${model}`
    if (brand) return brand
    if (model) return model

    return ''
  }
}
